<template lang="html">
  <div class="note-shell">
    <svg class="note-blank" width="342" height="372" viewBox="0 0 342 372" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M306 22C309.314 22 312 19.3137 312 16H315C316.657 16 318 17.3431 318 19V334C318 337.314 315.314 340 312 340H30C26.6863 340 24 337.314 24 334V19C24 17.3432 25.3431 16 27 16H30C30 19.3137 32.6863 22 36 22C39.3137 22 42 19.3137 42 16H48C48 19.3137 50.6863 22 54 22C57.3137 22 60 19.3137 60 16H66C66 19.3137 68.6863 22 72 22C75.3137 22 78 19.3137 78 16H84C84 19.3137 86.6863 22 90 22C93.3137 22 96 19.3137 96 16H102C102 19.3137 104.686 22 108 22C111.314 22 114 19.3137 114 16H120C120 19.3137 122.686 22 126 22C129.314 22 132 19.3137 132 16H138C138 19.3137 140.686 22 144 22C147.314 22 150 19.3137 150 16H156C156 19.3137 158.686 22 162 22C165.314 22 168 19.3137 168 16H174C174 19.3137 176.686 22 180 22C183.314 22 186 19.3137 186 16H192C192 19.3137 194.686 22 198 22C201.314 22 204 19.3137 204 16H210C210 19.3137 212.686 22 216 22C219.314 22 222 19.3137 222 16H228C228 19.3137 230.686 22 234 22C237.314 22 240 19.3137 240 16H246C246 19.3137 248.686 22 252 22C255.314 22 258 19.3137 258 16H264C264 19.3137 266.686 22 270 22C273.314 22 276 19.3137 276 16H282C282 19.3137 284.686 22 288 22C291.314 22 294 19.3137 294 16H300C300 19.3137 302.686 22 306 22Z" fill="white"/>
      </g>
      <defs>
        <filter id="filter0_dd" x="0" y="0" width="342" height="372" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="8"/>
          <feGaussianBlur stdDeviation="12"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="4"/>
          <feGaussianBlur stdDeviation="6"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>
    <section class="content">
      <slot />
    </section>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="stylus" scoped>
.note-shell
  position: relative
  width: 294px
  height: 324px
  margin: 0 auto
  image-rendering: crisp-edges

  .note-blank
    position: absolute
    top: calc(50% - 179px)
    left: calc(50% - 171px)
    width: 342px
    height: 372px

  .content
    position: absolute
    top: 17px // fix anti-aliasing line
    bottom: @top
    left: 0
    right: @left
    color: black
    padding: 0 16px
    padding-top: 1px // fix anti-aliasing line

    h1
      margin: 0
</style>
